import { ApiService } from "../api";

export interface IUserTableData {
	id: number;
	first_name: string;
	last_name: string;
	full_name: string;
	email: string;
	phone: string | null;
	role: string;
	active: boolean;
	is_in_roundrobin: boolean;
	leads_count: number;
	include_in_dashboard_stats: boolean;
}

/**
 * Service for user-related API calls.
 */
export class UserService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Fetch users for the admin table view.
	 * @param active - Whether to fetch active or archived users
	 */
	public async getUsersForTable(active: boolean = true): Promise<IUserTableData[]> {
		const response = await this.apiService.get("/api/v1/users/table", {
			active: active ? "true" : "false",
		});
		return response.json();
	}
}
